export function getDistance(firstPoint, secondPoint) {
  const deltaX = Math.abs(firstPoint.x - secondPoint.x);
  const deltaY = Math.abs(firstPoint.y - secondPoint.y);

  return Math.sqrt(deltaX ** 2 + deltaY ** 2);
}
